<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ $t('notificationManual.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <!-- begin vertical-box -->
    <div class="vertical-box with-grid inbox">
      <!-- begin vertical-box-column -->
      <div class="vertical-box-column width-400">
        <!-- begin vertical-box -->
        <div class="vertical-box">
          <!-- begin wrapper -->
          <!-- end wrapper -->
          <!-- begin vertical-box-row -->
          <div class="vertical-box-row">
            <!-- begin vertical-box-cell -->
            <div class="vertical-box-cell">
              <!-- begin vertical-box-inner-cell -->
              <div class="vertical-box-inner-cell">
                <!-- begin scrollbar -->
                <div data-height="100%">
                  <!-- begin wrapper -->
                  <div class="wrapper">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label class="col-form-label required">
                            {{ $t('notificationManual.mainProgram') }}
                          </label>
                          <treeselect
                            :load-options="loadProgramMain"
                            :options="acProgramMainOptions"
                            :placeholder="$t('typeForSearch')"
                            v-model="model.acp_id"
                          />
                          <div class="validate" v-if="errors.has('acp_id')">
                            {{ errors.first('acp_id') }}
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-form-label required">
                            {{ $t('notificationManual.subProgram') }}
                          </label>
                          <treeselect
                            :load-options="loadProgramSub"
                            :options="acProgramSubOptions"
                            :placeholder="$t('typeForSearch')"
                            :multiple="true"
                            :limit="1"
                            v-model="model.acps_id"
                          />
                          <div class="validate" v-if="errors.has('acps_id')">
                            {{ errors.first('acps_id') }}
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-form-label required">
                            {{ $t('notificationManual.gradeName') }}
                          </label>
                          <treeselect
                            :load-options="loadGrade"
                            :options="acGradeOptions"
                            :placeholder="$t('typeForSearch')"
                            :multiple="true"
                            :limit="1"
                            v-model="model.grade_id"
                          />
                          <div class="validate" v-if="errors.has('grade_id')">
                            {{ errors.first('grade_id') }}
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-form-label required">
                            {{ $t('notificationManual.deliveredTo') }}
                          </label>
                          <treeselect
                            :options="deliveredOptions"
                            :placeholder="$t('typeForSearch')"
                            :multiple="true"
                            :limit="2"
                            v-model="model.receiver_type"
                          />
                          <div
                            class="validate"
                            v-if="errors.has('receiver_type')"
                          >
                            {{ errors.first('receiver_type') }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end wrapper -->
                </div>
                <!-- end scrollbar -->
              </div>
              <!-- end vertical-box-inner-cell -->
            </div>
            <!-- end vertical-box-cell -->
          </div>
          <!-- end vertical-box-row -->
        </div>
        <!-- end vertical-box -->
      </div>
      <!-- end vertical-box-column -->
      <!-- begin vertical-box-column -->
      <div class="vertical-box-column bg-white">
        <!-- begin vertical-box -->
        <div class="vertical-box">
          <!-- begin wrapper -->
          <div class="wrapper bg-silver">
            <span class="btn-group">
              <ts-checkbox v-model="model.mobile" class="mr-5">
                {{ $t('notificationManual.mobile') }}
              </ts-checkbox>
              <ts-checkbox v-model="model.email" class="mr-5">
                {{ $t('notificationManual.email') }}
              </ts-checkbox>
              <ts-checkbox v-model="model.sms">
                {{ $t('notificationManual.sms') }}
              </ts-checkbox>
            </span>
            <span class="pull-right">
              <a href="#" class="btn btn-white btn-sm" @click.prevent="clear">
                <i class="fa fa-times f-s-14 m-r-3 m-r-xs-0 t-plus-1"></i>
                <span class="hidden-xs">
                  {{ $t('notificationManual.discard') }}
                </span>
              </a>
            </span>
          </div>
          <!-- end wrapper -->
          <!-- begin vertical-box-row -->
          <div class="vertical-box-row bg-white" style="height: 50vh">
            <!-- begin vertical-box-cell -->
            <div class="vertical-box-cell">
              <!-- begin vertical-box-inner-cell -->
              <div class="vertical-box-inner-cell">
                <!-- begin scrollbar -->
                <div class="overflow-scroll height-full p-15">
                  <!-- begin email form -->
                  <!-- begin email subject -->
                  <div class="email-subject">
                    <input
                      type="text"
                      v-model="model.not_subject"
                      class="form-control form-control-lg"
                      :placeholder="$t('notificationManual.subject')"
                      :class="{ 'is-invalid': errors.has('not_subject') }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('not_subject')"
                    >
                      {{ errors.first('not_subject') }}
                    </div>
                  </div>
                  <!-- end email subject -->
                  <!-- begin email content -->
                  <div class="email-content p-t-15">
                    <textarea
                      v-model="model.msg_content"
                      class="form-control"
                      style="height: 30vh"
                      :placeholder="$t('notificationManual.message')"
                    ></textarea>
                  </div>
                  <!-- end email content -->
                  <!-- end email form -->
                </div>
                <!-- end scrollbar -->
              </div>
              <!-- end vertical-box-inner-cell -->
            </div>
            <!-- end vertical-box-cell -->
          </div>
          <!-- end vertical-box-row -->
          <!-- begin wrapper -->
          <div class="wrapper bg-silver text-right">
            <ts-button
              class="btn-white p-l-40 p-r-40 m-r-5"
              @click="$emit('close')"
              >{{ $t('cancel') }}</ts-button
            >
            <ts-button
              color="primary"
              class="p-l-40 p-r-40"
              :waiting="sending"
              @click.prevent="send"
              >{{ $t('send') }}</ts-button
            >
          </div>
          <!-- end wrapper -->
        </div>
        <!-- end vertical-box -->
      </div>
      <!-- end vertical-box-column -->
    </div>
    <!-- end vertical-box -->
  </ts-card>
</template>
<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'create',
  data() {
    return {
      model: {
        acp_id: null,
        acps_id: [],
        grade_id: [],
        receiver_type: [1, 2, 3, 5],
        mobile: true,
        email: true,
        sms: true,
        not_subject: '',
        msg_content: ''
      },
      acProgramMainOptions: null,
      acProgramSubOptions: null,
      acGradeOptions: null,
      deliveredOptions: [
        {
          id: 1,
          label: 'Parent'
        },
        {
          id: 2,
          label: 'Student'
        },
        {
          id: 3,
          label: 'Staff'
        },
        {
          id: 5,
          label: 'Teacher'
        }
      ],
      sending: false,
      errors: new Errors()
    }
  },
  methods: {
    ...mapActions('notificationManual', [
      'fetchProgramMain',
      'fetchProgramSub',
      'fetchGrade'
    ]),
    async loadProgramMain({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.acProgramMainOptions = null
        let response = await this.fetchProgramMain()
        if (response != undefined || response != null) {
          this.acProgramMainOptions = response.data.map(el => ({
            id: el.acp_id,
            label: el.acp_name_foreign
          }))
        }
      }
    },
    async loadProgramSub({ action /*, callback*/ }) {
      if (this.model.acp_id == null || this.model.acp_id == undefined) return
      if (action === LOAD_ROOT_OPTIONS) {
        this.acProgramSubOptions = null
        if (this.model.acp_id) {
          await this.fetchProgramSub({
            acp_id: this.model.acp_id
          })
            .then(response => {
              if (response != undefined || response != null) {
                this.acProgramSubOptions = response.data.map(el => ({
                  id: el.acps_id,
                  label: el.acps_name_foreign
                }))
                response.data.map(el => this.model.acps_id.push(el.acps_id))
              }
            })
            .catch(error => {
              this.$toasted.error(error.message)
            })
        }
      }
    },
    async loadGrade({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.acGradeOptions = null
        if (this.model.acps_id) {
          await this.fetchGrade({
            acps_id: this.model.acps_id
          })
            .then(response => {
              if (response != undefined || response != null) {
                this.acGradeOptions = response.data.map(el => ({
                  id: el.grade_id,
                  label: el.grade_name_foreign
                }))
                response.data.map(el => this.model.grade_id.push(el.grade_id))
              }
            })
            .catch(error => {
              this.$toasted.error(error.message)
            })
        }
      }
    },
    clear() {
      this.model = {
        device_active: '',
        acp_id: null,
        acps_id: [],
        grade_id: [],
        receiver_type: [1, 2, 3, 5],
        mobile: true,
        email: true,
        sms: true,
        device_template: ''
      }
    },
    send() {
      this.errors = new Errors()
      this.sending = true

      this.$store
        .dispatch('notificationManual/send', this.model)
        .then(response => {
          this.sending = false
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.sending = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    }
  },
  watch: {
    'model.acp_id': function(value) {
      this.model.acps_id = []
      this.acProgramSubOptions = null
      if (value) {
        this.fetchProgramSub({ acp_id: value })
      }
    },
    'model.acps_id': function(value) {
      this.model.grade_id = []
      this.acGradeOptions = null
      if (value) {
        this.fetchGrade({ acps_id: value })
      }
    }
  }
}
</script>
